import { Component, OnInit, Input } from '@angular/core';
import { LetterOnBoard } from '@schoolbelle/api/letter-to-board';
import { MailMergeItem } from '@schoolbelle/api/letter';
import { GroupMember, GroupMemberService } from '@schoolbelle/api/group-member';
import { BoardService } from '@schoolbelle/api/board';
import { GroupService } from '@schoolbelle/api/group';

@Component({
  selector: 'app-mailmerge-nonadmin-viewer',
  templateUrl: './mailmerge-nonadmin-viewer.component.html',
  styleUrls: ['./mailmerge-nonadmin-viewer.component.css']
})
export class MailmergeNonadminViewerComponent implements OnInit {
  @Input() item:LetterOnBoard;
  @Input() content:string|{[lang:string]:string};
  @Input() lang:string;
  @Input() query:string;
  mailmerge:MailMergeItem[] = [];
  mailmerged_members:GroupMember[] = [];
  constructor(
    private member:GroupMemberService,
    private board:BoardService,
    private group:GroupService,
  ) { }
  ngOnInit() {
    this.mailmerge = this.item.mailmerge.filter(g=>g.group_id !== 0);
    this.mailmerge.forEach(mm_row=>{
      // mailmerge DOES NOT differenciate between a sutudent and their parents
      this.mailmerged_members.push(...this.member.getMine(mm_row.scopes, this.group.currentGroup.gid, this.board.currentBoard.type === 'facultynews' ? 'faculty_' : 'studentparent_').filter(m=>m.member_type !== 'parent'));
    })
  }
}
